// src/MobileHeader.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar'; // <-- Import our newly responsive sidebar module
import './MobileHeader.css';
import logoImage from './assets/icons/Recettes-R-Icon.png';

export default function MobileHeader() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleBrandClick = () => {
    navigate('/');
    setIsMenuOpen(false);
  };

  return (
    <>
      <div className="mobile-header flex h-14 items-center justify-between bg-white border-b border-gray-100 px-4 shrink-0 relative z-50">
        
        {/* Brand App Branding Area */}
        <div 
          className="flex items-center gap-2 max-w-[70%] overflow-hidden cursor-pointer"
          onClick={handleBrandClick}
        >
          <img 
            src={logoImage} 
            alt="Recettes Logo" 
            className="h-6 w-6 rounded-[5px] object-contain shrink-0 select-none block" 
          />
          <span className="text-lg font-bold tracking-wide text-[#e66a00] whitespace-nowrap truncate">
            Recettes
          </span>
        </div>
        
        {/* Hamburger Menu Button */}
        <button 
          onClick={toggleMenu}
          className="hamburger-btn flex flex-col justify-between w-6 h-4 bg-transparent border-none p-0 cursor-pointer outline-none"
          aria-label="Toggle Menu"
        >
          <span className={`bar ${isMenuOpen ? 'open-top' : ''}`}></span>
          <span className={`bar ${isMenuOpen ? 'open-mid' : ''}`}></span>
          <span className={`bar ${isMenuOpen ? 'open-bot' : ''}`}></span>
        </button>
      </div>

      {/* Slide-out Menu Panel */}
      <div className={`menu-panel ${isMenuOpen ? 'panel-open' : ''}`}>
        {/* FIXED: Removed internal custom nav-links and plugged in the Left-Aligned Sidebar component directly */}
        <div className="h-[calc(100vh-56px)] bg-white overflow-hidden">
          <Sidebar onItemClick={closeMenu} />
        </div>
      </div>

      {/* Dimmed Overlay background when menu is active */}
      {isMenuOpen && <div className="menu-overlay" onClick={toggleMenu} />}
    </>
  );
}